import * as types from '../constants/actionTypes';
import objectAssign from 'object-assign';
import update from 'immutability-helper';
// import $ from 'jquery';
import 'whatwg-fetch';
import * as utils from './actionUtils';
import toastr from 'toastr';
import { push } from 'react-router-redux';
// import dateHelper from '../utils/dateHelper';

let defaultDelay = 0;
if (process.env.NODE_ENV === 'development') {
  defaultDelay = 200;
}


// example of a thunk using the redux-thunk middleware
export function loadClubs() {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.getData('clubs/',
      (result) => {dispatch(loadClubsSuccess(result));},
      (error) => {dispatch(loadClubsFail(error));},
      defaultDelay);
    return dispatch({
      type: types.LOAD_CLUBS,
    });
  };
}

export function loadClubsSuccess(clubList) {
  return {
    type: types.LOAD_CLUBS_SUCCESS,
    clubList: clubList,
    clubListUpdated: Date.now(),
  };
}

export function loadClubDetails(id) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.getData('clubs/' + id,
      (result) => {dispatch(loadClubDetailsSuccess(result));},
      (error) => {dispatch(loadClubsFail(error));},
      defaultDelay);
    return dispatch({
      type: types.LOAD_CLUB_DETAILS,
    });
  };
}

export function loadClubDetailsSuccess(clubDetails) {
  return {
    type: types.LOAD_CLUB_DETAILS_SUCCESS,
    clubDetails: clubDetails,
    clubDetailsUpdated: Date.now(),
  };
}

export function loadClubsFail(error) {
  return function(dispatch) {
    dispatch({
      type: types.LOAD_CLUB_DETAILS_FAILURE,
      errors: error,
    });
  };
}

export function updateClub(clubDetails) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.sendData('clubs/' + clubDetails.id, 'PUT', clubDetails,
      (result) => {dispatch(updateClubSuccess(result));},
      (errors) => {dispatch(updateClubFail(errors));},
      defaultDelay);
  };
}

export function createClub(clubDetails) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.sendData('clubs/', 'POST', clubDetails,
      (result) => {dispatch(createClubSuccess(result));},
      (errors) => {dispatch(updateClubFail(errors));},
      defaultDelay);
  };
}

export function updateClubSuccess(clubDetails) {
  return function(dispatch) {
    toastr.success('Lagret');
    dispatch({
      type: types.LOAD_CLUB_DETAILS_SUCCESS,
      clubDetails: clubDetails,
      clubDetailsUpdated: Date.now(),
    });
  };
}

export function createClubSuccess(clubDetails) {
  return function(dispatch) {
    toastr.success('Opprettet');
    dispatch(push('/klubb/' + clubDetails.id + '/rediger'));
    dispatch({
      type: types.LOAD_CLUB_DETAILS_SUCCESS,
      clubDetails: clubDetails,
      clubDetailsUpdated: Date.now(),
    });
  };
}

export function updateClubFail(errors) {
  return function(dispatch) {
    toastr.warning('Lagring feilet');
    dispatch({
      type: types.LOAD_CLUB_DETAILS_FAILURE,
      errors: errors,
    });
  };
}

export function deleteClub(id) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.deleteData('clubs/' + id, () => {
      dispatch(push('/klubber'));
      toastr.success('Slettet');
    }, defaultDelay);
  };
}

export function updateClubImage(club_id, image) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    let data = new FormData();
    data.append('image', image);
    utils.sendFormData('clubs/' + club_id + '/image', 'PUT', data,
      (result) => {dispatch(updateClubImageSuccess(result));},
      (result) => {dispatch(updateClubFail(result));},
      defaultDelay);
  };
}

export function updateClubImageSuccess(result) {
  return function(dispatch, getState) {
    toastr.success('Bilde oppdatert');
    // debugger;
    let clubDetails = objectAssign({}, getState().clubs.clubDetails);
    clubDetails.image = result.image;
    clubDetails.image_thumbnail = result.image_thumbnail;
    dispatch({
      type: types.LOAD_CLUB_DETAILS_SUCCESS,
      clubDetails: clubDetails,
      clubDetailsUpdated: Date.now(),
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/clubActions.js
 **/